import React, { useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { FaUserPlus } from 'react-icons/fa';
import { HiEye, HiEyeOff } from 'react-icons/hi';
import apiService from '../services/apiService';

const RegisterPage = ({ onVoltar }) => {
    const [formData, setFormData] = useState({
        nome: '',
        email: '',
        telefone: '',
        chave: '',
        senha: '',
        confirmarSenha: ''
    });

    const [loading, setLoading] = useState(false);
    const [modernAlert, setModernAlert] = useState({ show: false, type: '', message: '' });
    const [showSenha, setShowSenha] = useState(false);
    const [showConfirmarSenha, setShowConfirmarSenha] = useState(false);

    const showModernAlert = (message, type = 'success') => {
        setModernAlert({ show: true, type, message });
        setTimeout(() => {
            setModernAlert({ show: false, type: '', message: '' });
        }, 5000);
    };

    const handleInputChange = (field, value) => {
        setFormData({ ...formData, [field]: value });
    };

    const handleCadastrar = async () => {
        try {
            setLoading(true);

            if (!formData.nome || !formData.email || !formData.senha || !formData.confirmarSenha) {
                showModernAlert('Preencha todos os campos obrigatórios (Nome, Email e Senhas).', 'error');
                return;
            }

            if (formData.senha !== formData.confirmarSenha) {
                showModernAlert('As senhas não coincidem.', 'error');
                return;
            }

            const response = await apiService.registrar({
                nome: formData.nome,
                email: formData.email,
                telefone: formData.telefone,
                chave: formData.chave,
                senha: formData.senha
            });

            if (response.success) {
                showModernAlert(response.message || 'Cadastro realizado com sucesso! Aguarde a verificação do administrador.', 'success');
                setTimeout(() => {
                    onVoltar();
                }, 2000);
            }
        } catch (error) {
            showModernAlert(error.message || 'Erro ao realizar cadastro.', 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {/* Modern Alert Notification */}
            {modernAlert.show && (
                <div
                    style={{
                        position: 'fixed',
                        top: '2rem',
                        right: '2rem',
                        zIndex: 9999,
                        maxWidth: '400px',
                        background: modernAlert.type === 'success' ? '#003B6B' : '#dc3545',
                        color: 'white',
                        padding: '1rem 1.5rem',
                        borderRadius: '1rem',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                        border: 'none',
                        fontWeight: '600',
                        fontSize: '0.95rem',
                        animation: 'slideInRight 0.5s ease-out',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.75rem'
                    }}
                >
                    <div style={{
                        width: '2rem',
                        height: '2rem',
                        background: 'rgba(255, 255, 255, 0.2)',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0
                    }}>
                        {modernAlert.type === 'success' ? '✓' : '✕'}
                    </div>
                    <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: '700', marginBottom: '0.25rem' }}>
                            {modernAlert.type === 'success' ? 'Sucesso!' : 'Erro!'}
                        </div>
                        <div style={{ opacity: 0.9, fontSize: '0.9rem' }}>
                            {modernAlert.message}
                        </div>
                    </div>
                    <button
                        onClick={() => setModernAlert({ show: false, type: '', message: '' })}
                        style={{
                            background: 'none',
                            border: 'none',
                            color: 'white',
                            cursor: 'pointer',
                            padding: '0.25rem',
                            borderRadius: '0.25rem',
                            opacity: 0.7,
                            fontSize: '1.2rem',
                            lineHeight: 1,
                            transition: 'opacity 0.2s'
                        }}
                        onMouseEnter={(e) => e.target.style.opacity = 1}
                        onMouseLeave={(e) => e.target.style.opacity = 0.7}
                    >
                        ×
                    </button>
                </div>
            )}

            <Container fluid className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
                <div style={{ width: '100%', maxWidth: '900px' }}>
                <div
                    className="bg-gradient-to-r from-slate-700 to-slate-600"
                    style={{
                        padding: '20px',
                        borderRadius: '8px 8px 0 0',
                        marginBottom: '0',
                        color: 'white'
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <FaUserPlus size={24} />
                        <h4 style={{ fontWeight: 'bold', margin: 0 }}>Cadastrar novo usuário</h4>
                    </div>
                </div>

                <div style={{ backgroundColor: 'white', padding: '40px', borderRadius: '0 0 8px 8px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-3">
                                <Form.Label style={{ fontWeight: 'bold' }}>Nome</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={formData.nome}
                                    onChange={(e) => handleInputChange('nome', e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-3">
                                <Form.Label style={{ fontWeight: 'bold' }}>E-mail</Form.Label>
                                <Form.Control
                                    type="email"
                                    value={formData.email}
                                    onChange={(e) => handleInputChange('email', e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label style={{ fontWeight: 'bold' }}>
                                    Telefone <span style={{ fontWeight: 'bold', color: '#6c757d' }}>(opcional)</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    value={formData.telefone}
                                    onChange={(e) => handleInputChange('telefone', e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label style={{ fontWeight: 'bold' }}>
                                    Chave <span style={{ fontWeight: 'bold', color: '#6c757d' }}>(opcional)</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    value={formData.chave}
                                    onChange={(e) => handleInputChange('chave', e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label style={{ fontWeight: 'bold' }}>Senha</Form.Label>
                                <div style={{ position: 'relative' }}>
                                    <Form.Control
                                        type={showSenha ? "text" : "password"}
                                        value={formData.senha}
                                        onChange={(e) => handleInputChange('senha', e.target.value)}
                                        style={{ paddingRight: '40px' }}
                                    />
                                    <Button
                                        variant="link"
                                        onClick={() => setShowSenha(!showSenha)}
                                        style={{
                                            position: 'absolute',
                                            right: '10px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            border: 'none',
                                            background: 'none',
                                            padding: '0',
                                            cursor: 'pointer',
                                            color: '#6c757d',
                                            zIndex: 10
                                        }}
                                        aria-label={showSenha ? "Ocultar senha" : "Mostrar senha"}
                                    >
                                        {showSenha ? <HiEyeOff size={20} /> : <HiEye size={20} />}
                                    </Button>
                                </div>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label style={{ fontWeight: 'bold' }}>Confirmar senha</Form.Label>
                                <div style={{ position: 'relative' }}>
                                    <Form.Control
                                        type={showConfirmarSenha ? "text" : "password"}
                                        value={formData.confirmarSenha}
                                        onChange={(e) => handleInputChange('confirmarSenha', e.target.value)}
                                        style={{ paddingRight: '40px' }}
                                    />
                                    <Button
                                        variant="link"
                                        onClick={() => setShowConfirmarSenha(!showConfirmarSenha)}
                                        style={{
                                            position: 'absolute',
                                            right: '10px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            border: 'none',
                                            background: 'none',
                                            padding: '0',
                                            cursor: 'pointer',
                                            color: '#6c757d',
                                            zIndex: 10
                                        }}
                                        aria-label={showConfirmarSenha ? "Ocultar senha" : "Mostrar senha"}
                                    >
                                        {showConfirmarSenha ? <HiEyeOff size={20} /> : <HiEye size={20} />}
                                    </Button>
                                </div>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mt-4">
                        <Col className="d-flex justify-content-center gap-3">
                            <Button
                                variant="danger"
                                onClick={onVoltar}
                                style={{
                                    backgroundColor: '#dc3545',
                                    borderColor: '#dc3545',
                                    padding: '10px 40px',
                                    fontWeight: 'bold',
                                    borderRadius: '8px'
                                }}
                            >
                                Voltar
                            </Button>
                            <Button
                                variant="primary"
                                onClick={handleCadastrar}
                                disabled={loading}
                                style={{
                                    backgroundColor: '#003B6B',
                                    borderColor: '#003B6B',
                                    padding: '10px 40px',
                                    fontWeight: 'bold',
                                    borderRadius: '8px'
                                }}
                            >
                                {loading ? 'Cadastrando...' : 'Cadastrar'}
                            </Button>
                        </Col>
                    </Row>
                </div>
            </div>
        </Container>
        </>
    );
};

export default RegisterPage;
